export const lightTheme = {
  '--color-primary': '#2563eb',
  '--color-primary-dark': '#1d4ed8',
  '--color-success': '#16a34a',
  '--color-warning': '#ca8a04',
  '--color-error': '#dc2626',
  '--color-surface': '#ffffff',
  '--color-surface-secondary': '#f9fafb',
  '--color-text': '#111827',
  '--color-text-secondary': '#6b7280',
  '--color-border': '#e5e7eb',
  '--color-gray-50': '#f9fafb',
  '--color-gray-100': '#f3f4f6',
  '--color-gray-200': '#e5e7eb',
  '--color-gray-300': '#d1d5db',
  '--color-gray-400': '#9ca3af',
  '--color-gray-500': '#6b7280',
  '--color-gray-600': '#4b5563',
  '--color-gray-700': '#374151',
  '--color-gray-800': '#1f2937',
  '--color-gray-900': '#111827',
}

export const darkTheme = {
  '--color-primary': '#3b82f6',
  '--color-primary-dark': '#2563eb',
  '--color-success': '#22c55e',
  '--color-warning': '#eab308',
  '--color-error': '#ef4444',
  '--color-surface': '#1f2937',
  '--color-surface-secondary': '#111827',
  '--color-text': '#f9fafb',
  '--color-text-secondary': '#9ca3af',
  '--color-border': '#374151',
  '--color-gray-50': '#111827',
  '--color-gray-100': '#1f2937',
  '--color-gray-200': '#374151',
  '--color-gray-300': '#4b5563',
  '--color-gray-400': '#6b7280',
  '--color-gray-500': '#9ca3af',
  '--color-gray-600': '#d1d5db',
  '--color-gray-700': '#e5e7eb',
  '--color-gray-800': '#f3f4f6',
  '--color-gray-900': '#f9fafb',
}

export type ThemeTokens = typeof lightTheme
